import './style.css'
import { DisplayDateReportFormat } from '../../helpers/texthelper'
import {
  calculateAgingDay,
  calculateAmount,
  getPaymentObjectivesType,
  getStatusDate
} from '../../helpers/reportHelper'

export const AgingReport = (reportData: any) => {
  const rightNow = new Date()
  const csvData: any[] = []
  const rowHearder: any[] = []
  rowHearder.push('วันที่ออกรายงาน')
  rowHearder.push('เลขที่ใบรับเงินออนไลน์')
  rowHearder.push('วันที่ออกใบรับเงินออนไลน์')
  rowHearder.push('รหัสตัวแทนผู้ออกใบรับเงินฯ')
  rowHearder.push('ชื่อตัวแทนผู้ออกใบรับเงินฯ')
  rowHearder.push('รหัสสาขา/AO')
  rowHearder.push('ชื่อสาขา')
  rowHearder.push('กรมธรรม์เลขที่')
  rowHearder.push('ชื่อ-สกุล ผู้ชำระเบี้ย')
  rowHearder.push('ชื่อ-สกุล ผู้เอาประกันภัย')
  rowHearder.push('จำนวนเงินที่ชำระ')
  rowHearder.push('ประเภทการจ่ายเบี้ย')
  rowHearder.push('สถานะใบรับเงินฯ')
  rowHearder.push('วันที่สถานะล่าสุด  statusDate')
  rowHearder.push('Aging (จำนวนวันนับจากวันที่ออก e-TR)')
  rowHearder.push('เหตุผลที่ส่งงานล่าช้า')
  csvData.push(rowHearder)
  const createCSVData = () => {
    reportData.data &&
      reportData.data.forEach((item: any) => {
        const rowData: any[] = []
        rowData.push(DisplayDateReportFormat(new Date()))
        rowData.push(item.receiptNo)
        rowData.push(DisplayDateReportFormat(item.receiptdate))
        rowData.push(item.agent.agentId)
        rowData.push(item.agent.name)
        rowData.push(item.branchCode || item.agent.branchCode)
        rowData.push(item.branchName || item.agent.branchName)
        rowData.push(item.policyNo)
        rowData.push(item.payerName)
        rowData.push(item.insuredName)
        rowData.push(calculateAmount(item.paymentObjectives))
        rowData.push(getPaymentObjectivesType(item.paymentObjectives))
        rowData.push(item.status)
        rowData.push(DisplayDateReportFormat(getStatusDate(item)))
        rowData.push(calculateAgingDay(item))
        rowData.push(item.submissionDelayReason)
        csvData.push(rowData)
      })
    //setCsvResult(csvData)
    return csvData
  }

  return createCSVData()
}
